import type { SearchOrdersParams } from './orders.api';

// ─── Query Keys ───────────────────────────────────────────────────────────────

export const orderKeys = {
  all: ['orders'] as const,
  detail: (id: string): readonly unknown[] => [...orderKeys.details(), id] as const,
  details: (): readonly string[] => [...orderKeys.all, 'detail'] as const,
  history: (id: string): readonly unknown[] => [...orderKeys.all, 'history', id] as const,
  list: (params: SearchOrdersParams): readonly unknown[] => [...orderKeys.lists(), params] as const,
  lists: (): readonly string[] => [...orderKeys.all, 'list'] as const,
  statusHistory: (id: string): readonly unknown[] => [...orderKeys.all, 'statusHistory', id] as const,
  tasks: (orderId: string): readonly unknown[] => [...orderKeys.all, 'tasks', orderId] as const,
};
